import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic  } from 'antd';
import {balanceOf,signer,transfer,allowance,init,transferFrom} from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import NumberFormat from 'react-number-format'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { updateBonus, getInfo,loginAdmin, getTixianRecord,addDepositBuy,addUsdtState,addUsdtState1,getLiushui, testJing,testDong} from "../../api";
import { CSSTransition } from 'react-transition-group';
import { stringify } from 'qs';
import {useNavigate} from "react-router-dom";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Manad = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
   


    
    const [isLock,setIsLock]=useState(false)

    const [tab,setTab] = useState(0)
    const [allReg, setAllReg] = useState("")
    const [allRegUsdtMore, setAllRegUsdtMore] = useState("")
    const [allRegUsdtO, setAllRegUsdtO] = useState("")
    const [star1, setStar1] = useState("")
    const [star2, setStar2] = useState("")
    const [star3, setStar3] = useState("")
    const [star4, setStar4] = useState("")
    const [star5, setStar5] = useState("")
    const [star6, setStar6] = useState("")
    const [vrpPoolNum, setVrpPoolNum] = useState("")
    const [vrpPool, setVrpPool] = useState("")
    const [poolBonus, setPoolBonus] = useState("")
    const [poolBonusCopy, setPoolBonusCopy] = useState("")
    const [testPoolBonus, setTestPoolBonus] = useState("")
     const [list,setList] = useState([])

    const _setTab = (e) =>{
        setTab(e)
    }

    const _testJing= () =>{
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
      
        if(!testPoolBonus){
            message.error("请输入数量")
            return false
        }
        if(testPoolBonus.length<=0){
            message.error("请输入数量")
            return false
        }
        if(testPoolBonus>33333){
            message.error("不能大于33333")
            return false
        }

        if(testPoolBonus<=0){
            message.error("不能小于0")
            return false
        }

        if(isLock){
            return false
        }
        setIsLock(true)
        message.warning("发起静态测试",2)
        signer(props.address).then(res=>{
            testJing({address:props.address,value:String(testPoolBonus),pass:res.pass}).then(res=>{
                if(res.code===0){
                    message.success(res.msg,1)
                    setNum(num+1)
                }else{
                    message.error(res.msg)
                }
                setIsLock(false)
                
                
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            setIsLock(false)
        })


    }

    const _testDong= () =>{
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
      
        if(!testPoolBonus){
            message.error("请输入数量")
            return false
        }
        if(testPoolBonus.length<=0){
            message.error("请输入数量")
            return false
        }
        if(testPoolBonus>33333){
            message.error("不能大于33333")
            return false
        }

        if(testPoolBonus<=0){
            message.error("不能小于0")
            return false
        }

        if(isLock){
            return false
        }
        setIsLock(true)
        message.warning("发起动态测试",2)
        signer(props.address).then(res=>{
            testDong({address:props.address,value:String(testPoolBonus),pass:res.pass}).then(res=>{
                if(res.code===0){
                    message.success(res.msg,1)
                    setNum(num+1)
                }else{
                    message.error(res.msg)
                }
                setIsLock(false)
                
                
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            setIsLock(false)
        })


    }

    const _updateBonus= () =>{
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
      
        if(!poolBonus){
            message.error("请输入数量")
            return false
        }
        if(poolBonus.length<=0){
            message.error("请输入数量")
            return false
        }
        if(poolBonus>33333){
            message.error("不能大于33333")
            return false
        }

        if(poolBonus<=0){
            message.error("不能小于0")
            return false
        }

        if(isLock){
            return false
        }
        setIsLock(true)

        signer(props.address).then(res=>{
            updateBonus({address:props.address,value:String(poolBonus),pass:res.pass}).then(res=>{
                if(res.code===0){
                    message.success(res.msg,1)
                    setNum(num+1)
                }else{
                    message.error(res.msg)
                }
                setIsLock(false)
                
                
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            setIsLock(false)
        })


    }

    




    const _getInfo= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        // if(props.address.length<=0){
        //     message.error(t('head.请先连接钱包'))
        //     return false
        // }
        getInfo().then(res=>{
            if(res.code === 0 ){
            
                //补全那些变量  格式： setAllReg = res.data.allReg
                setAllReg(res.data.allReg)
                setAllRegUsdtMore(res.data.allRegUsdtMore)
                setAllRegUsdtO(res.data.allRegUsdtO)
                setStar1(res.data.star1)
                setStar2(res.data.star2)
                setStar3(res.data.star3)
                setStar4(res.data.star4)
                setStar5(res.data.star5)
                setStar6(res.data.star6)
                setVrpPoolNum(res.data.vrpPoolNum)
                setVrpPool(res.data.vrpPool)
                setPoolBonus(res.data.poolBonus)
                setPoolBonusCopy(res.data.poolBonus)
                setList(res.data.list|| [])

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }
    



     const connectWallet = () =>{ 
        //       const timestamp = parseInt(new Date().getTime() /1000);
        // console.log(timestamp)
                     
        // if(timestamp<1755603000){
        //     message.error(t('g.暂未开始'))
        //             return false
        // }
                 init().then(
                                res=>{
                                    loginAdmin({address:res.address,pass:res.pass}).then(res1=>{
                                        if (res1.code == 0){
                                            message.success(t('head.连接成功'),.5)
                                            //props.setIsLogin(res1.data.has)
                                            if(!res1.data.has){
                                               
                                                message.warn(t('head.您还未绑定钱包，请绑定激活钱包地址'))
                                                // props.setFlash(!props.flash)
                                                return
                                            }else{
                                                props.setIsLogin(true)
                                            }
                                        }else{
                                            props.setAddress("")
                                            message.error(res1.msg)
                                        }
                                },err=>{
                                    props.setAddress("")
                                    message.error(t('head.连接失败')+"请检测您的网络环境")
                                } )
                
                            })
            
            
        }

 

   

    
    
    const shua =()=>{
        window.scrollTo(0, 0)
        _getInfo()
    }


    useEffect(() => {
            // window.scrollTo(0, 0)
             _getInfo()
            // _balanceOf()
            // _balanceOf1()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>  


      
        {/*  */}
            <div  className='  mx-auto w-full lg:w-1/3 flex flex-row justify-between items-center h-16 bg-black  text-white px-4 fixed top-0 headzindex999'>
                        
                        <div  className='w-1/12 flex flex-row items-center justify-start'>
                            
                            
                            <span onClick={shua} className=' text-xs text-yellow-500'>刷新</span>
                        </div>
                        <div  className='  w-1/12  flex flex-row justify-center items-center relative'>
                    
                              <span onClick={()=>_setTab(0)} className=' text-xs text-yellow-500'>认购</span>
                                         
                            
                                               
                         </div>
                         <div  className='  w-1/12  flex flex-row justify-center items-center relative'>
                    
                              <span onClick={()=>_setTab(1)} className=' text-xs text-yellow-500'>矿池</span>
                                         
                            
                                               
                         </div>
                         <div  className='  w-1/12  flex flex-row justify-center items-center relative'>
                    
                              <span onClick={()=>_setTab(2)} className=' text-xs text-yellow-500'>测算</span>
                                         
                            
                                               
                         </div>
                         {/* <div  className='  w-2/12  flex flex-row justify-center items-center relative'>
                    
                              <span onClick={()=>_setTab(1)} className=' text-xs text-yellow-500'>发放记录</span>
                                         
                            
                                               
                         </div> */}
                        <div className=' w-3/12 flex flex-row justify-center items-center'>
                        {
                                !props.isLogin?(
                                    <button onClick={connectWallet} className=' w-full h-8 border-2 border-text-act text-text-act rounded-full  text-sm text-center font-bold'>{t('head.连接钱包')}</button>
                                ):(
                                    <button className=' w-full h-8 border border-text-act text-text-act rounded-full  font-extrabold text-xs text-center px-2' style={{direction: 'rtl',overflow:'hidden',textOverflow:'ellipsis'}}>{props.address}</button>
                                )
                            }
                            
                        </div>
            
                       
                        
                       
                        
                    </div>
            
            {
                tab == 0&&props.isLogin?(
                    <div className='w-full lg:w-1/3 pl-4 pr-10 pt-20 text-white flex flex-col gap-4'>
                        {/* 
                        放置后台一些基本数据，每行左面是标题，后边是数据
                        1.总注册地址数：allReg
                        2.大于100U地址数量：allRegUsdtMore
                        3.usdt总持有量：allRegUsdtO
                        4.一星到六星每级别地址数量：star1，star2...
                        
                        */}
                        
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">总注册地址数</span>
                            <span>{allReg}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-pink-400">大于100U地址数量</span>
                            <span className="text-pink-400">{allRegUsdtMore}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-pink-400">USDT总持有量</span>
                            <span className="text-pink-400"><NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={allRegUsdtO}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">一星地址数量</span>
                            <span>{star1}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">二星地址数量</span>
                            <span>{star2}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">三星地址数量</span>
                            <span>{star3}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">四星地址数量</span>
                            <span>{star4}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">五星地址数量</span>
                            <span>{star5}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">六星地址数量</span>
                            <span>{star6}</span>
                        </div>
                            
                    </div>
                ):tab==1&&props.isLogin?(
                    <div  className='  w-full lg:w-1/3  px-4 pt-20  text-white flex flex-col '>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">当前矿池余额VRP</span>
                            <span><NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={vrpPool}
                                    prefix=""
                                    decimalSeparator="."
                                    fixedDecimalScale={true}
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={2} /></span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-white/10">
                            <span className="text-white/70">当前质押人数</span>
                            <span>{vrpPoolNum}</span>
                        </div>
                        <div className="flex justify-between py-2 ">
                            <span className="text-white/70">发放收益数量：{poolBonusCopy}</span>
                        </div>
                    
                        <div className="w-full h-10 mt-1 rounded-sm flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #0161F6 solid"}} >
                            <input onInput={(e)=>setPoolBonus(e.target.value)} value={poolBonus}  type="number"   className=' w-4/5 h-12 text-lg text-black input1 '  placeholder="输入发放数量"></input>
                            <span   className='w-1/5 h-10   flex flex-row justify-end items-center text-right text-sm text-gray-500'>VRP</span>
                        </div>
                                       
                        <div className=' w-full mt-5 mb-4 flex flex-row justify-end items-center'>
                            <button onClick={_updateBonus}  className='w-full h-10 bg-blue-600     text-white rounded-md  text-sm text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>修改提交</span></button>
                        </div>
                    </div>
                ):tab==2&&props.isLogin?(
                    <div  className='  w-full lg:w-1/3  px-4 pt-16  text-white flex flex-col '>
                        <div className="flex justify-between py-2 ">
                            <span className="text-white/70">测算发放数量：</span>
                        </div>
                    
                        <div className="w-full h-10 mt-1 rounded-sm flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #0161F6 solid"}} >
                            <input onInput={(e)=>setTestPoolBonus(e.target.value)} value={testPoolBonus}  type="number"   className=' w-4/5 h-12 text-lg text-black input1 '  placeholder="输入发放数量"></input>
                            <span   className='w-1/5 h-10   flex flex-row justify-end items-center text-right text-sm text-gray-500'>VRP</span>
                        </div>
                                       
                        <div className=' w-full mt-5 mb-4 flex flex-row justify-end items-center gap-2'>
                            <button onClick={_testJing}  className='w-full h-10 bg-blue-600     text-white rounded-md  text-sm text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>测算静态</span></button>
                            <button onClick={_testDong}  className='w-full h-10 bg-blue-400     text-white rounded-md  text-sm text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>测算动态</span></button>
                        </div>

                        <div className="flex justify-between py-2 ">
                            <span className="text-white/70">测算记录：</span>
                        </div>

                        <div  className=' w-full min-h-48  flex flex-col  text-white text-[11px]'>
                            {
                                list.length>0?
                                list.map((item,index)=>{
                                    return(
                                        <div  key ={item.id}>
                                            {/* 根据item.op判断显示哪个
                                            1.类型 测试时间  发放总量 实际发放量 收益人数 权重总和  最佳持币数 
                                            2.类型 测试时间  发放总量 实际发放量 收益人数 全网算力总和   */}
                                            {
              item.classes === "jing" ? (
                // op=1：类型 测试时间 发放总量 实际发放量 收益人数 权重总和 最佳持币数
                <>
                <div className="grid grid-cols-2 lg:grid-cols-7 gap-1">
                  <span className="text-gray-400">测试时间：{item.add_time}</span>
                  <span className="text-yellow-400">类型：静态测算</span>
                  <span className="text-gray-400">收益人数：{item.num}</span>
                  <span className="text-gray-400">权重总和：{item.all_pai}</span>
                  <span className="text-gray-400">发放总量：<NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={item.all_num}
                                    prefix=""
                                    decimalSeparator="."
                                    fixedDecimalScale={true}
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={2} /></span>
                  <span className="text-gray-400">实际发放：<NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={item.fa_num}
                                    prefix=""
                                    decimalSeparator="."
                                    fixedDecimalScale={true}
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={2} /></span>
                  <span className="text-gray-100">最佳持币：<NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={item.hold_num}
                                    prefix=""
                                    decimalSeparator="."
                                    fixedDecimalScale={true}
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={2} /></span>
                </div>
                <div className='my-2 w-full h-px bg-gray-800'></div>
                </>
              ) : (
                // op=其他：类型 测试时间 发放总量 实际发放量 收益人数 全网算力总和
                <>
                    <div className="grid grid-cols-2 lg:grid-cols-6 gap-1">
                        <span className="text-gray-400">测试时间：{item.add_time}</span>
                        <span className="text-orange-600">类型：动态测算</span>
                        <span className="text-gray-400">收益人数：{item.num}</span>
                        <span className="text-gray-400"><NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={item.all_power}
                                    prefix=""
                                    decimalSeparator="."
                                    fixedDecimalScale={true}
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={2} /></span>
                        <span className="text-gray-400">发放总量：<NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={item.all_num}
                                    prefix=""
                                    decimalSeparator="."
                                    fixedDecimalScale={true}
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={2} /></span>
                        <span className="text-gray-400">实际发放：<NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={item.fa_num}
                                    prefix=""
                                    decimalSeparator="."
                                    fixedDecimalScale={true}
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={false}
                                    decimalScale={2} /></span>
                    </div>
                    <div className='my-2 w-full h-px bg-gray-800'></div>
                </>
                
              )
            }
                                        </div>
                                        
                                    )
                                }):(
                                    
                                    <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-xs'>
                                            暂无测算记录
                                    </div>
                                )
                            }
    
                            
                                
                        </div>
                    </div>
                ):(
                    <div  className=' w-full h-28  pt-20 flex flex-row items-center justify-center text-gray-600 text-xs'>
                                            请先连接钱包
                                    </div>
                )
            }
            
           
            <div  className=' w-full h-[200px]'></div>
                
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{
        setLan(value){
            const action ={type:"setLan",value:value}
            dispatch(action)
        },
        setAddress(value){
            const action ={type:"setAddress",value:value}
            dispatch(action)
        },
        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },
        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Manad);
